import React from "react";

import { QRCodeSVG } from "qrcode.react";

import { getValFromLS } from "../helpers";

export default function ContactsCallout() {
	return (
		<div className="contacts-callout-container">
			<div className="contacts-callout-container-left">
				<QRCodeSVG
					value={`https://vtofriendraising.netlify.app/auto-signin/${getValFromLS(
						"friendsDash",
						true,
					)}`}
					size={128}
				/>
			</div>

			<div className="contacts-callout-container-middle">
				<span>New for 2026-2027</span>
				<p>
					Scan the QR Code to easily manage your potential donors and contacts
					directly on your mobile device.
				</p>
			</div>

			<div className="contacts-callout-container-right"></div>
		</div>
	);
}
